<template>
  <div>
    <b-row>
      <b-col>
        <b-table
          responsive
          striped
          bordered
          :fields="risklevelFields"
          :items="riskLevelItems"
          :class="['roundedReportTable', { 'mb-0': !riskLevelItems.length }]"
          thead-class="d-none"
        >
          <template v-slot:cell(description)="rowitem">
            <div
              v-for="(items, index) in rowitem.item.description"
              :key="items"
            >
              <div v-if="index === 1">Note Log:</div>
              <div class="mb-1 text-wrap">{{ items }}</div>
            </div>
          </template>
          <template v-slot:cell(risk)="rowitem">
              {{ rowitem.item.risk }}
          </template>
          <template v-slot:cell(caution)="rowitem">
              {{ rowitem.item.caution }}
          </template>
          <template v-slot:cell(update)="rowitem">
            <div class="mb-1">
              <b-link v-if="!readOnly" class="fraudReportLink" @click="addupdate(rowitem.item.update, rowitem.item.caution)">Update</b-link>
              <span v-else v-b-tooltip.hover.left class="text-muted" :title="featureDisabled">Update</span>
            </div>
          </template>
        </b-table>
        <NoRecordFound
          v-if="!riskLevelItems.length && RISK_ERROR === null"
          message-required
        ></NoRecordFound>
      </b-col>
    </b-row>
    <CustomMessage v-if="RISK_ERROR !== null" :custom-msg="RISK_ERROR" class="riskTable" />
  </div>
</template>

<script>
import NoRecordFound from '@/src/components/_norecord-found'
import constant from '@constants/constant.json'
import CustomMessage from '@/src/components/_custom-message.vue'
export default {
  components: {
    NoRecordFound,
    CustomMessage,
  },
  props: {
    riskIndicators: {
      type: Array,
      default: () => [],
    },
    riskError: {
      type: String,
      default: '',
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      featureDisabled: constant.featureDisabled,
      riskStatus: constant.RiskIndicatorItems,
    }
  },
  computed: {
    riskLevelItems() {
      return this.riskIndicators
    },
    RISK_ERROR() {
      return this.riskError
    },
    risklevelFields() {
      return [
        {
          key: 'attribute',
          label: '',
        },
        {
          key: 'risk',
          label: 'Risk Level',
          tdClass: (value) => {
            if (value === this.riskStatus.high) {
              return this.$style.statusFail;
            }
            if (value === this.riskStatus.medium) {
              return this.$style.statusMedium;
            }
            return this.$style.statusLow;
          },
          tdAttr: (value) => {
            let bgColor = '';
            if (value === this.riskStatus.high) bgColor = '#f7d9d4';
            else if (value === this.riskStatus.medium) bgColor = '#f9eee6';
            else bgColor = '#e7f1e4';
            return {
              style: `background-color: ${bgColor} !important;`
            };
          }
        },
        {
          key: 'description',
          label: '',
        },
        {
          key: 'caution',
          label: 'Caution Level',
          tdClass: (value) => {
            if (value === this.riskStatus.caution) {
              return this.$style.statusFail;
            }
            return '';
          },
          tdAttr: (value) => {
            if (value === this.riskStatus.caution) {
              return {
                style: 'background-color: #f7d9d4 !important;'
              };
            }
            return {};
          }
        },
        {
          key: 'update',
          label: '',
        }
      ]
    },
  },
  methods: {
    addupdate(id, name) {
      this.$emit('addupdated', id, name)
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';
:global(table) > :global(tbody) > :global(tr) > :global(td).statusFail {
  padding: 2px 8px !important;
  font-weight: 700;
  color: $color-accent-red;
}
:global(table) > :global(tbody) > :global(tr) > :global(td).statusMedium {
  padding: 2px 8px !important;
  font-weight: 700;
  color: $color-accent-orange;
}
:global(table) > :global(tbody) > :global(tr) > :global(td).statusLow {
  padding: 2px 8px !important;
  font-weight: 700;
  color: $color-accent-green;
}
</style>

<style lang="scss" scoped>
@import 'src/design/_redesign.scss';
/* stylelint-disable selector-pseudo-element-no-unknown */
.riskTable {
  margin: 0 0 !important;
}
a.fraudReportLink {
  color: $color-dark-purple;
  text-decoration: underline;
}

::v-deep .roundedReportTable {
  overflow: hidden;
  border-radius: 4px;
}

::v-deep .roundedReportTable table {
  overflow: hidden;
  border-spacing: 0;
  border-collapse: separate;
  border-radius: 4px;

  tbody tr:first-child td:first-child {
    border-top-left-radius: 4px;
  }

  tbody tr:first-child td:last-child {
    border-top-right-radius: 4px;
  }

  tbody tr:last-child td:first-child {
    border-bottom-left-radius: 4px;
  }

  tbody tr:last-child td:last-child {
    border-bottom-right-radius: 4px;
  }
}
</style>
